/*
  Layout for training session and videos
*/

import { ReactComponent as TWMLogo } from '@/assets/logo_twm.svg'
import { ReactComponent as TWMLogoSuffix } from '@/assets/logo_twm_suffix.svg'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Toolbar from '@mui/material/Toolbar'
import { Outlet } from 'react-router-dom'

import { connect } from 'react-redux'

const GuestLayout = () => (
  <>
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        background: theme => theme.palette.other.grey[20].main,
      }}
    >
      <CssBaseline />
      <AppBar
        color=""
        sx={{
          justifyContent: 'center',
          background: theme => theme.palette.primary.main,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            alignItems: 'center',
            display: 'flex',
            borderBottom: theme => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Toolbar>
            <TWMLogo />
            <TWMLogoSuffix />
          </Toolbar>
        </Box>
      </AppBar>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  </>
)

export default connect(() => ({}))(GuestLayout)
